<template>
    <div class='text-left mini-padding'>
        <v-data-table
            :headers="tableHeaders"
            :items="atendimentos"
            sort-by="PRIORIDADE"
            class="elevation-4 tableCalls"
            :loading="loading"
            :loading-text="labels.textLoading"
            :no-data-text="labels.textNoData"
            v-resize="onResize"
            :search="search"
            dense
            :sort-desc="false"
            :items-per-page=50
            :footer-props="{
                'items-per-page-text': labels.itemsPerPage,
                showFirstLastpage:true,
                'items-per-page-options':[10, 50, 100]
            }"
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <div style="width:100%; display: flex; height: inherit;">
                        <div style="width:30%; display: flex; align-items: center;">
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                :label="labels.buscar"
                                single-line
                                hide-details
                            ></v-text-field>
                        </div>
                        <v-divider
                            class="mx-4"
                            inset
                            vertical
                        />
                        <div style="width:66%; display: flex;">
                            <div style="display: flex; align-items: center;">
                                <v-btn class="btnFilter" icon @click.stop="changeFilterDrawerWidth">
                                    <v-icon>
                                        mdi-filter-plus
                                    </v-icon>
                                </v-btn>
                            </div>
                            <div class="filtersColumn">
                                <v-chip
                                    v-for="filter in filterValues"
                                    :key="filter.value.ID"
                                    style="margin:1px;"
                                >
                                    <span style="padding: 0px !important;" class="pr-2 noCloseFilters">
                                        {{ filter.title + (!filter.dontShowValues ? ': ' + (filter.value.NOME || filter.value.ID || filter.value) : '')}}
                                    </span>
                                    <v-btn
                                        style="position: relative; right: -16px;"
                                        icon
                                        @click="removeFilterAndGetCalls(filter)"
                                    >
                                        <v-icon color="red">
                                            mdi-close-circle
                                        </v-icon>
                                    </v-btn>
                                </v-chip>
                            </div>
                        </div>
                    </div>
                </v-toolbar>
                <v-divider></v-divider>
            </template>
            <template v-slot:[`item.DATA_INICIO`]="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <div style="padding:5px;padding-left:15px;"
                            class="text-truncate"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <span style=" margin-left:-15px;">{{ item.DATA_INICIO ? moment(item.DATA_INICIO).format('DD/MM/YYYY') : '' }}</span>
                        </div>
                    </template>
                    <span>{{ item.DATA_INICIO ? moment(item.DATA_INICIO).format('DD/MM/YYYY') : '' }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.DATA_LIMITE`]="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <div style="padding:5px;padding-left:15px;"
                            class="text-truncate"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <span style=" margin-left:-15px;">{{ item.DATA_LIMITE ? moment(item.DATA_LIMITE).format('DD/MM/YYYY') : '' }}</span>
                        </div>
                    </template>
                    <span>{{ item.DATA_LIMITE ? moment(item.DATA_LIMITE).format('DD/MM/YYYY') : '' }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.ID`]="{ item }">
                <v-tooltip top>
                     <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind="attrs"
                            v-on="on"
                        >
                            <span class="text-truncate">{{item.ID}}</span>
                        </div>
                    </template>
                    <span>{{ item.ID }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.PEDIDO`]="{ item }">
                <v-tooltip top>
                     <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind="attrs"
                            v-on="on"
                        >
                            <span class="text-truncate" style="margin-left:-15px;">{{item.PEDIDO}}</span>
                        </div>
                    </template>
                    <span>{{ item.PEDIDO }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.ASSUNTO`]="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <div 
                            class="text-truncate assuntoColumn"
                            v-bind="attrs"
                            v-on="on"
                        >
                            {{ item.ASSUNTO }}
                        </div>
                    </template>
                    <span>{{ item.ASSUNTO }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.SITUACAO`]="{ item }">
                <v-chip
                    v-if="item.SITUACAO"
                    class="ma-2 chipSituation"
                    :color="item.SITUACAO_COR"
                    text-color="white"
                >
                    {{item.SITUACAO | translate('AtendimentosTable')}}
                </v-chip>
            </template>
            <template v-slot:[`item.CLIENTE`]="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <div 
                            style="display: flex; align-items: center;"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-avatar
                                class="avatar"
                                size="40px"
                            >
                                <img
                                    alt="Avatar"
                                    width="40"
                                    height="40"
                                    :src="getAvatarimage(item.IMAGEM_CLIENTE)"
                                >
                            </v-avatar>
                            <div 
                                class="text-truncate assuntoColumn"
                                style="margin-left: .5rem;"
                            >
                                <span > {{ item.CLIENTE }} </span>
                            </div>
                        </div>
                    </template>
                    <span>{{ item.CLIENTE }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.ULTIMA_ACAO`]="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <div 
                            v-bind="attrs"
                            v-on="on"
                            style="display: flex; align-items: center;"
                        >
                            <v-avatar
                                v-if="item.RESPONSAVEL"
                                class="avatar"
                                size="40px"
                            >
                                <img
                                    alt="Avatar"
                                    width="40"
                                    height="40"
                                    :src="getAvatarimage(item.IMAGEM_RESPONSAVEL)"
                                >
                            </v-avatar>
                            <div 
                                class="text-truncate"
                                style="margin-left: .5rem;"
                            >
                                <span>{{item.RESPONSAVEL}}</span>
                            </div>
                        </div>
                    </template>
                    <span>{{item.RESPONSAVEL}}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.SOLICITANTES`]="{ item }">
                <v-tooltip v-for="requester in item.callRequesters" :key="requester.USUARIO_ID" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-avatar
                            class="avatar"
                            size="30px"
                            v-bind="attrs"
                            v-on="on"
                            style="margin-right: .5rem;"
                        >
                            <img
                                alt="Avatar"
                                width="30"
                                height="30"
                                :src="getAvatarimage(requester.IMAGEM_PERFIL)"
                            >
                        </v-avatar>
                    </template>
                    <span>{{requester.NOME}}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.RESPONSAVEIS`]="{ item }">
                <v-tooltip v-for="responsible in item.callResponsibles" :key="responsible.USUARIO_ID" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-avatar
                            class="avatar"
                            size="30px"
                            v-bind="attrs"
                            v-on="on"
                            style="margin-right: .5rem;"
                        >
                            <img
                                alt="Avatar"
                                width="30"
                                height="30"
                                :src="getAvatarimage(responsible.IMAGEM_PERFIL)"
                            >
                        </v-avatar>
                    </template>
                    <span>{{responsible.NOME}}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.PRIORIDADE`]="{ item }">
                <span>{{item.PRIORIDADE_DESCRICAO}}</span>
            </template>
            <template v-slot:[`item.actionCustomer`]="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <div 
                            class="labelBadge"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <div class="badge" v-if="item.noCustomerViews">
                                <span>{{item.noCustomerViews}}</span>
                            </div>
                            <v-btn 
                                icon 
                                @click="saveBackUrl()"
                                :to="'/atendimento?id=' + item.ID + '&callType=customer'"
                            >
                                <v-icon
                                    color="#1976d2"
                                >
                                    mdi-face-agent
                                </v-icon>
                            </v-btn>
                        </div>
                    </template>
                    <span>{{ 'Atendimento cliente' | translate('AtendimentosTable') }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.actionOperator`]="{ item }" v-if="this.isUserOperator">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <div 
                            class="labelBadge"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <div class="badge" v-if="item.noOperatorViews">
                                <span>{{item.noOperatorViews}}</span>
                            </div>
                            <v-btn 
                                icon 
                                @click="saveBackUrl()"
                                :to="'/atendimento?id=' + item.ID + '&callType=operator'"
                            >
                                <v-icon
                                    color="#1976d2"
                                >
                                    mdi-account-tie
                                </v-icon>
                            </v-btn>
                        </div>
                    </template>
                    <span>{{ 'Atendimento operador' | translate('AtendimentosTable') }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`footer.page-text`]="items">
                <span style="font-weight: bolder;">{{items.pageStop}}</span> de {{items.itemsLength}}

            </template>
        </v-data-table>
        <v-navigation-drawer
            class="filtersDrawer"
            v-model="filterDrawer"
            fixed
            permanent
            right
            :width="filterDrawerWidth"
            v-resize="onResize"
            v-click-outside-custom="closeDrawer"
            @mousedown="''"
            color="#ececec"
            app
            
        >
                <v-list style="padding: 10px;">
                    <v-list-item disabled>
                        <v-list-item-icon>
                            <v-icon large>
                                mdi-filter
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;">
                            <v-list-item-title class="text-left">
                                {{'Filtros' | translate('AtendimentosTable')}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-progress-linear v-if="loadingFilterOptions" indeterminate/>
                <v-divider v-else/>
                <div v-if="loadingFilterOptions" class="text-caption text-center pt-2">
                    {{'Carregando filtros' | translate('AtendimentosTable')}}
                </div>
                <v-list class="filtersBody">
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;" v-if="!!filters.ID">
                            <v-combobox
                                    class="noCloseFilters"
                                    dense
                                    v-model="filters.ID.values"
                                    :items="filterOptions.calls"
                                    :label="filters.ID.title"
                                    item-text="ID"
                                    item-value="ID"
                                    hide-selected
                                    chips
                                    multiple
                                    :menu-props="{closeOnContentClick:true}"
                                >
                                    <template v-slot:selection="{ attrs, item, parent, selected }">
                                        <v-chip
                                            :key="JSON.stringify(item.ID)"
                                            v-if="item === Object(item)"
                                            v-bind="attrs"
                                            :input-value="selected.value"
                                            @click:close="parent.selectItem(item.value)"
                                            class="kndChip"
                                        >
                                            <span class="pr-2 noCloseFilters">
                                                {{ 'Nº: ' + item.ID }}
                                            </span>
                                            <v-btn
                                                icon
                                                @click="parent.selectItem(item)"
                                            >
                                                <v-icon color="red">
                                                    mdi-close-circle
                                                </v-icon>
                                            </v-btn>
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item`]="{ item }">
                                        <span class="pr-2 noCloseFilters">
                                            {{ 'Nº: ' + item.ID }}
                                        </span>
                                    </template>
                                    <template v-slot:no-data>
                                        <span> </span>
                                    </template>
                                </v-combobox>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;" v-if="!!filters.ACAO_COM_USUARIO_ID">
                            <v-row>
                                <v-col cols="10">
                                    <v-combobox
                                        class="noCloseFilters"
                                        dense
                                        v-model="filters.ACAO_COM_USUARIO_ID.values"
                                        :items="filterOptions.responsibles"
                                        :label="filters.ACAO_COM_USUARIO_ID.title"
                                        item-text="NOME"
                                        item-value="ID"
                                        return-object
                                        hide-selected
                                        chips
                                        multiple
                                        :menu-props="{closeOnContentClick:true}"
                                    >
                                        <template v-slot:selection="{ attrs, item, parent, selected }">
                                            <v-chip
                                                :key="JSON.stringify(item.ID)"
                                                v-if="item === Object(item)"
                                                v-bind="attrs"
                                                :input-value="selected.value"
                                                @click:close="parent.selectItem(item.value)"
                                                class="kndChip"
                                            >
                                                <v-avatar 
                                                    size="22"
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2 noCloseFilters">
                                                    {{ item.NOME }}
                                                </span>
                                                <v-btn
                                                    icon
                                                    @click="parent.selectItem(item)"
                                                >
                                                    <v-icon 
                                                        color="red"
                                                        class="noCloseFilters"
                                                    >
                                                        mdi-close-circle
                                                    </v-icon>
                                                </v-btn>
                                            </v-chip>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <v-avatar 
                                                class="noCloseFilters"
                                                size="22" 
                                                style="margin-right:5px;"  
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            <span class="pr-2 noCloseFilters">
                                                {{ item.NOME }}
                                            </span>
                                        </template>
                                        <template v-slot:no-data>
                                            <span> </span>
                                        </template>
                                    </v-combobox>
                                </v-col>
                                <v-col cols="2" style="position: relative;">
                                    <div class="exception-label">
                                        {{labels.exception}}
                                    </div>
                                    <v-checkbox
                                        v-model="filters.ACAO_COM_USUARIO_ID.exception"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;" v-if="!!filters.CLIENTE_ID">
                            <v-row>
                                <v-col cols="10">
                                    <v-combobox
                                            class="noCloseFilters"
                                            dense
                                            v-model="filters.CLIENTE_ID.values"
                                            :items="filterOptions.clients"
                                            :label="filters.CLIENTE_ID.title"
                                            item-text="NOME"
                                            item-value="ID"
                                            hide-selected
                                            return-object
                                            chips
                                            multiple
                                            :menu-props="{closeOnContentClick:true}"
                                            :disabled="!!user.CLIENTE_ID"
                                    >
                                        <template v-slot:selection="{ attrs, item, parent, selected }">
                                            <v-chip
                                                :key="JSON.stringify(item.ID)"
                                                v-if="item === Object(item)"
                                                v-bind="attrs"
                                                :input-value="selected.value"
                                                @click:close="parent.selectItem(item.value)"
                                                class="kndChip"
                                            >
                                                <v-avatar 
                                                    size="22"
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2 noCloseFilters">
                                                    {{ item.NOME }}
                                                </span>
                                                <v-btn
                                                    icon
                                                    @click="parent.selectItem(item)"
                                                >
                                                    <v-icon 
                                                        color="red"
                                                        class="noCloseFilters"
                                                    >
                                                        mdi-close-circle
                                                    </v-icon>
                                                </v-btn>
                                            </v-chip>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <v-avatar 
                                                class="noCloseFilters"
                                                size="22" 
                                                style="margin-right:5px;"  
                                            >
                                                <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                            </v-avatar>
                                            <span class="pr-2 noCloseFilters">
                                                {{ item.NOME }}
                                            </span>
                                        </template>
                                        <template v-slot:no-data>
                                            <span> </span>
                                        </template>
                                    </v-combobox>
                                </v-col>
                                <v-col cols="2" style="position: relative;">
                                    <div class="exception-label">
                                        {{labels.exception}}
                                    </div>
                                    <v-checkbox
                                        v-model="filters.CLIENTE_ID.exception"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;">
                            <date-picker v-model="filters.DATA_INICIO.values[0]" :placeholder="labels.data_inicio_de" format="DD/MM/YYYY" valueType="format" style="width: 100%; margin: 15px 0px;"/>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;">
                            <date-picker v-if="enableDate()" v-model="filters.DATA_INICIO.values[1]" :placeholder="labels.data_inicio_ate" format="DD/MM/YYYY" valueType="format" style="width: 100%; margin: 15px 0px;" />
                            <date-picker v-else v-model="filters.DATA_INICIO.values[1]" :placeholder="labels.data_inicio_ate" format="DD/MM/YYYY" valueType="format" style="width: 100%; margin: 15px 0px;" disabled />
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;">
                            <date-picker v-model="filters.DATA_LIMITE.values[0]" :placeholder="labels.data_limite_de" format="DD/MM/YYYY" valueType="format" style="width: 100%; margin: 15px 0px;"/>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;">
                            <date-picker v-if="enableEndDate()" v-model="filters.DATA_LIMITE.values[1]" :placeholder="labels.data_limite_ate" format="DD/MM/YYYY" valueType="format" style="width: 100%; margin: 15px 0px;" />
                            <date-picker v-else v-model="filters.DATA_LIMITE.values[1]" :placeholder="labels.data_limite_ate" format="DD/MM/YYYY" valueType="format" style="width: 100%; margin: 15px 0px;" disabled />
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;" v-if="!!filters.SOLICITANTE_ID">
                            <v-row>
                                <v-col cols="10">
                                    <v-combobox
                                            class="noCloseFilters"
                                            dense
                                            v-model="filters.SOLICITANTE_ID.values"
                                            :items="filterOptions.callRequesters"
                                            :label="filters.SOLICITANTE_ID.title"
                                            item-text="NOME"
                                            item-value="ID"
                                            hide-selected
                                            return-object
                                            chips
                                            multiple
                                            :menu-props="{closeOnContentClick:true}"
                                        >
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <v-chip
                                                    :key="JSON.stringify(item.ID)"
                                                    v-if="item === Object(item)"
                                                    v-bind="attrs"
                                                    :input-value="selected.value"
                                                    @click:close="parent.selectItem(item.value)"
                                                    class="kndChip"
                                                >
                                                    <v-avatar 
                                                        size="22"
                                                        style="margin-right:5px;"  
                                                    >
                                                        <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                    </v-avatar>
                                                    <span class="pr-2 noCloseFilters">
                                                        {{ item.NOME }}
                                                    </span>
                                                    <v-btn
                                                        icon
                                                        @click="parent.selectItem(item)"
                                                    >
                                                        <v-icon 
                                                            color="red"
                                                            class="noCloseFilters"
                                                        >
                                                            mdi-close-circle
                                                        </v-icon>
                                                    </v-btn>
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item`]="{ item }">
                                                <v-avatar 
                                                    class="noCloseFilters"
                                                    size="22" 
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2 noCloseFilters">
                                                    {{ item.NOME }}
                                                </span>
                                            </template>
                                            <template v-slot:no-data>
                                                <span> </span>
                                            </template>
                                    </v-combobox>
                                </v-col>
                                <v-col cols="2" style="position: relative;">
                                    <div class="exception-label">
                                        {{labels.exception}}
                                    </div>
                                    <v-checkbox
                                        v-model="filters.SOLICITANTE_ID.exception"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content style="padding: 10px 0px 0px 0px;" v-if="!!filters.RESPONSAVEL_ID">
                            <v-row>
                                <v-col cols="10">
                                    <v-combobox
                                            class="noCloseFilters"
                                            dense
                                            v-model="filters.RESPONSAVEL_ID.values"
                                            :items="filterOptions.callResponsibles"
                                            :label="filters.RESPONSAVEL_ID.title"
                                            item-text="NOME"
                                            item-value="ID"
                                            hide-selected
                                            return-object
                                            chips
                                            multiple
                                            :menu-props="{closeOnContentClick:true}"
                                        >
                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                                <v-chip
                                                    :key="JSON.stringify(item.ID)"
                                                    v-if="item === Object(item)"
                                                    v-bind="attrs"
                                                    :input-value="selected.value"
                                                    @click:close="parent.selectItem(item.value)"
                                                    class="kndChip"
                                                >
                                                    <v-avatar 
                                                        size="22"
                                                        style="margin-right:5px;"  
                                                    >
                                                        <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                    </v-avatar>
                                                    <span class="pr-2 noCloseFilters">
                                                        {{ item.NOME }}
                                                    </span>
                                                    <v-btn
                                                        icon
                                                        @click="parent.selectItem(item)"
                                                    >
                                                        <v-icon 
                                                            color="red"
                                                            class="noCloseFilters"
                                                        >
                                                            mdi-close-circle
                                                        </v-icon>
                                                    </v-btn>
                                                </v-chip>
                                            </template>
                                            <template v-slot:[`item`]="{ item }">
                                                <v-avatar 
                                                    class="noCloseFilters"
                                                    size="22" 
                                                    style="margin-right:5px;"  
                                                >
                                                    <img :src="item.IMAGEM_PERFIL ? baseUrl + item.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span class="pr-2 noCloseFilters">
                                                    {{ item.NOME }}
                                                </span>
                                            </template>
                                            <template v-slot:no-data>
                                                <span> </span>
                                            </template>
                                    </v-combobox>
                                </v-col>
                                <v-col cols="2" style="position: relative;">
                                    <div class="exception-label">
                                        {{labels.exception}}
                                    </div>
                                    <v-checkbox
                                        v-model="filters.RESPONSAVEL_ID.exception"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="noCloseFilters">
                        <v-list-item-content class="noCloseFilters" style="padding: 10px 0px 0px 0px;" v-if="!!filters.SITUACAO_ID">
                            <v-row>
                                <v-col cols="10">
                                    <v-combobox
                                        class="noCloseFilters"
                                        dense
                                        v-model="filters.SITUACAO_ID.values"
                                        :items="filterOptions.situations"
                                        :label="filters.SITUACAO_ID.title"
                                        item-text="NOME"
                                        item-value="ID"
                                        hide-selected
                                        return-object
                                        chips
                                        multiple
                                        :menu-props="{closeOnContentClick:true}"
                                    >
                                        <template v-slot:selection="{ attrs, item, parent, selected }">
                                            <v-chip
                                                :key="JSON.stringify(item.ID)"
                                                v-if="item === Object(item)"
                                                v-bind="attrs"
                                                :input-value="selected.value"
                                                @click:close="parent.selectItem(item.value)"
                                                class="kndChip"
                                            >
                                                <v-avatar
                                                    class="noCloseFilters"
                                                    :color="item.COR"
                                                    size="18"
                                                    style="margin-right: 1em;"
                                                ></v-avatar>
                                                <span class="pr-2 noCloseFilters">
                                                    {{ item.NOME }}
                                                </span>
                                                <v-btn
                                                    icon
                                                    @click="parent.selectItem(item)"
                                                >
                                                    <v-icon 
                                                        color="red"
                                                        class="noCloseFilters"
                                                    >
                                                        mdi-close-circle
                                                    </v-icon>
                                                </v-btn>
                                            </v-chip>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <v-avatar
                                                class="noCloseFilters"
                                                :color="item.COR"
                                                size="18"
                                                style="margin-right: 1em;"
                                            ></v-avatar>
                                            <span class="pr-2 noCloseFilters">
                                                {{ item.NOME }}
                                            </span>
                                        </template>
                                        <template v-slot:no-data>
                                            <span> </span>
                                        </template>
                                    </v-combobox>
                                </v-col>
                                <v-col cols="2" style="position: relative;">
                                    <div class="exception-label">
                                        {{labels.exception}}
                                    </div>
                                    <v-checkbox
                                        v-model="filters.SITUACAO_ID.exception"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="noCloseFilters">
                        <v-list-item-content 
                            class="noCloseFilters" 
                            style="padding: 10px 0px 0px 0px; justify-content: end;"
                        >
                            <v-checkbox
                                v-model="filters.NAO_LIDOS.values[0]"
                                :label="filters.NAO_LIDOS.title"
                            >
                            </v-checkbox>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="noCloseFilters">
                        <v-list-item-content 
                            class="noCloseFilters" 
                            style="padding: 10px 0px 0px 0px; justify-content: end;"
                        >
                            <v-text-field
                                v-model="filters.TEXTO_MENSAGEM.values[0]"
                                append-icon="mdi-magnify"
                                :label="filters.TEXTO_MENSAGEM.title"
                                single-line
                            ></v-text-field>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="noCloseFilters">
                        <v-list-item-content class="noCloseFilters" style="padding: 10px 0px 0px 0px;" v-if="!!filters.SETOR_ID">
                            <v-row>
                                <v-col cols="10">
                                    <v-combobox
                                        class="noCloseFilters"
                                        dense
                                        v-model="filters.SETOR_ID.values"
                                        :items="filterOptions.sections"
                                        :label="filters.SETOR_ID.title"
                                        item-text="DESCRICAO"
                                        item-value="ID"
                                        hide-selected
                                        return-object
                                        chips
                                        multiple
                                        :menu-props="{closeOnContentClick:true}"
                                    >
                                        <template v-slot:selection="{ attrs, item, parent, selected }">
                                            <v-chip
                                                :key="JSON.stringify(item.ID)"
                                                v-if="item === Object(item)"
                                                v-bind="attrs"
                                                :input-value="selected.value"
                                                @click:close="parent.selectItem(item.value)"
                                                class="kndChip"
                                            >
                                                <span class="pr-2 noCloseFilters">
                                                    {{ item.NOME }}
                                                </span>
                                                <v-btn
                                                    icon
                                                    @click="parent.selectItem(item)"
                                                >
                                                    <v-icon 
                                                        color="red"
                                                        class="noCloseFilters"
                                                    >
                                                        mdi-close-circle
                                                    </v-icon>
                                                </v-btn>
                                            </v-chip>
                                        </template>
                                        <template v-slot:[`item`]="{ item }">
                                            <span class="pr-2 noCloseFilters">
                                                {{ item.NOME }}
                                            </span>
                                        </template>
                                        <template v-slot:no-data>
                                            <span> </span>
                                        </template>
                                    </v-combobox>
                                </v-col>
                                <v-col cols="2" style="position: relative;">
                                    <div class="exception-label">
                                        {{labels.exception}}
                                    </div>
                                    <v-checkbox
                                        v-model="filters.SETOR_ID.exception"
                                    >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider/>
                <footer class="filtersFooter">
                    <v-spacer/>
                    <v-btn 
                        class="btn1"
                        dark
                        small
                        @click="clearFilters()"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                        {{'Limpar' | translate('AtendimentosTable')}}
                    </v-btn>
                    <v-spacer/>
                    <v-btn 
                        class="btn1"
                        dark
                        small
                        @click="setFilters(filters), getAllCallsBySituation()"
                    >
                        <v-icon>
                            mdi-check
                        </v-icon>
                        {{'Aplicar' | translate('AtendimentosTable')}}
                    </v-btn>
                    <v-spacer/>
                </footer>
        </v-navigation-drawer>
    </div>
</template>

<script>
import translate from '../../../src/plugins/translate'
import getAllCallsByCompanyIdAndUserId from '../../../src/app/atendimento/getAllCallsByCompanyIdAndUserId'
import getAllByCompanyIdAndSituationIdAndUserId from '../../../src/app/atendimento/getAllByCompanyIdAndSituationIdAndUserId'
import DatePicker from 'vue2-datepicker'
import { createNamespacedHelpers } from 'vuex'
import { eventBus } from '../../../src/plugins/bus'
import { v4 } from 'uuid'
import clickOutsideCustom from '../../../src/plugins/clickOutsideCustom'
import filterWorker from 'worker-loader!@/app/atendimento/filterWorker.js'

const user = createNamespacedHelpers('user')
const filters = createNamespacedHelpers('callFilters')

export default {
    name: 'AtendimentosTable',
    components: {DatePicker},
    directives: {
        clickOutsideCustom
    },
    data() {
        return {
            loading: false,
            loadingFilterOptions: false,
            search: null,
            filterDrawer: false,
            filterDrawerWidth: '0px',
            labels: {
                textLoading: translate('Carregando atendimentos', 'AtendimentosTable'),
                textNoData: translate('Nenhum registro localizado', 'AtendimentosTable'),
                buscar: translate('Buscar', 'AtendimentosTable'),
                data_inicio_de: translate('Data Início De','AtendimentosTable'),
                data_inicio_ate: translate('Data Início Até','AtendimentosTable'),
                data_limite_de: translate('Data Limite De','AtendimentosTable'),
                data_limite_ate: translate('Data Limite Até','AtendimentosTable'),
                itemsPerPage: translate('Itens Por Página','AtendimentosTable'),
                exception: translate('Exceção', 'AtendimentosTable')
            },
            imageTime: new Date().getTime(),
            atendimentos:[],
            tableHeaders: [
                { text: translate('Número', 'Atendimentos'), value: 'ID', width: '11%', align:'center'},
                { text: translate('Pedido', 'Atendimentos'), value: 'PEDIDO', width: '8%', align:'center'},
                { text: translate('Cliente', 'Atendimentos'), value: 'CLIENTE', width: '11%' },
                { text: translate('Assunto', 'Atendimentos'), value: 'ASSUNTO', width: '8%' },
                { text: translate('Data de Início', 'Atendimentos'), value: 'DATA_INICIO', width: '18%', align:'center' },
                { text: translate('Data Limite', 'Atendimentos'), value: 'DATA_LIMITE', width: '18%', align:'center' },
                { text: translate('Solicitantes', 'Atendimentos'), value: 'SOLICITANTES', width: '12%', align:'start'},
                { text: translate('Responsáveis', 'Atendimentos'), value: 'RESPONSAVEIS', width: '13%'},
                { text: translate('Ação com', 'Atendimentos'), value: 'ULTIMA_ACAO', width: '13%', align:'start'},
                { text: translate('Situação', 'Atendimentos'), value: 'SITUACAO', width: '10%', align:'center' },
                { text: '', value: 'actionCustomer', sortable: false, width: '4%', align:'end' },
                { text: '', value: 'actionOperator', sortable: false, width: '4%', align:'end' },
                { text: translate('Prioridade', 'Atendimentos'), value: 'PRIORIDADE', width: '13%', align:'start'},
            ],
            defaultImage: require('../../../src/assets/user.png'),
            baseUrl: process.env.VUE_APP_API_URL,
            floatingAvatarmenu: document.getElementById('floatingAvatarmenu'),
            floatingWarnings: document.getElementsByClassName('floatingMenuWarning'),
            isUserOperator: null,
            routeParams: {},
            getCallExecutionUniqueIds: []
        }
    },
    computed:{
        ...user.mapGetters(['user']),
        ...filters.mapGetters(['filters']),
        ...filters.mapGetters(['filterOptions']),
        ...filters.mapGetters(['filterValues']),

    },
    methods: {
        ...filters.mapActions(['setFilters', 'setFilterOptions', 'setFilterValues']),
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        },
        async loadFilterOptions() {
            if(this.loadingFilterOptions) return
            this.loadingFilterOptions = true

            var binds = {companyId:this.user.EMPRESA_ID, userId:this.user.USUARIO_ID, filters: {}, customerId: this.user.CLIENTE_ID, hidesUnlinkedCall: this.user.OCULTAR_ATEND_NAO_VINCULADO, userRoleDescription: this.user.FUNCAO_USUARIO_DESCRICAO }
            if(this.user.ADM == 'S'){
                binds.isAdmin = true
            }
            try {
                const response = await getAllCallsByCompanyIdAndUserId(binds)
                await this.buildFilters(response.data)
            } finally {
                this.loadingFilterOptions = false
            }
        },
        async getAllCallsBySituation(noFilters){
            const executionUniqueId = v4()
            this.getCallExecutionUniqueIds.push(executionUniqueId)

            this.loading = true
            this.closeDrawer()
            var binds = {companyId:this.user.EMPRESA_ID, situationCallId:this.getRouteParams().id, userId:this.user.USUARIO_ID, filters: noFilters ? {} : this.filters, hidesUnlinkedCall: this.user.OCULTAR_ATEND_NAO_VINCULADO, userRoleDescription: this.user.FUNCAO_USUARIO_DESCRICAO }
            if(this.user.ADM == 'S'){
                binds.isAdmin = true
            }
            if(this.user.CLIENTE_ID){
                this.filters.CLIENTE_ID.values = [{label:'CLIENTE_ID', ID: this.user.CLIENTE_ID, NOME: this.user.CLIENTE_NOME}]
            }
            await getAllByCompanyIdAndSituationIdAndUserId(binds)
                .then(function(response){
                    const isLastExecution = executionUniqueId === this.getCallExecutionUniqueIds[this.getCallExecutionUniqueIds.length - 1]

                    if(this.getRouteParams().id === binds.situationCallId && isLastExecution) this.atendimentos = response.data
                    if(isLastExecution){
                        this.getCallExecutionUniqueIds = []
                        this.loading = false
                    } 
                }.bind(this))
            this.buildFilterValues()
        },
        buildFilters(array) {
            return new Promise(function(resolve, reject){
                const worker = new filterWorker()

                worker.onmessage = function(e){
                    this.setFilterOptions(e.data)
                    worker.terminate()
                    resolve()
                }.bind(this)
                worker.onerror = function(error){
                    worker.terminate()
                    reject(error)
                }

                worker.postMessage(array)
            }.bind(this))
        },
        buildFilterValues() {
            const dontShowValuesLabels = ['NAO_LIDOS']
            this.setFilterValues([])
            var arrFilters = Object.values(this.filters)
            this.$nextTick(function(){
                for(let i = 0; i < arrFilters.length; i++){
                    for(let y = 0; y < arrFilters[i].values.length; y++){
                        if(!arrFilters[i].values[y]) continue
                        let value = {
                            title: arrFilters[i].title,
                            value: arrFilters[i].values[y],
                            dontShowValues: dontShowValuesLabels.includes(arrFilters[i].label)
                        }
                        if(!this.filterValues.some(function(item){ return JSON.stringify(item) == JSON.stringify(value)})) this.filterValues.push(value)
                    }
                }
                this.setFilterValues(this.filterValues)
            })
        },
        getAvatarimage(image) {
            return image ? this.baseUrl + image + '?t=' + this.imageTime : this.defaultImage
        },
        saveBackUrl(){
            localStorage.setItem('backToUrl', window.location.pathname)
        },
        async getRouteAction() {
            const isFilterOptionsEmpty = JSON.stringify(this.filterOptions) === JSON.stringify(this.getEmptyFilterOptions())
            if(isFilterOptionsEmpty) this.loadFilterOptions()

            await this.getAllCallsBySituation()
        },
        changeFilterDrawerWidth() {
            if(this.filterDrawerWidth == '0px'){
                this.filterDrawerWidth = '480px'
                if(this.floatingAvatarmenu) this.floatingAvatarmenu.style.right ='488px'
                if(this.floatingWarnings && this.floatingWarnings.length) for(const fw of this.floatingWarnings) fw.style.right ='488px'
            } else {
                this.filterDrawerWidth = '0px'
                if(this.floatingAvatarmenu) this.floatingAvatarmenu.style.right ='8px'
                if(this.floatingWarnings && this.floatingWarnings.length) for(const fw of this.floatingWarnings) fw.style.right ='8px'
            }
        },
        closeDrawer(event) {
            if(event){
                let target = event.target
                let found = false
                while(target && !found){
                    if(target.className.includes('floatingMenuWidth')) found = true
                    if(target.className.includes('mx-datepicker-body')) found = true
                    if(target.className.includes('mdi-filter')) found = true
                    if(target.className.includes('noCloseFilters')) found = true
                    if(target.className.includes('v-list v-select-list v-sheet theme--light v-list--dense theme--light')) found = true
                    if(target.firstElementChild && target.firstElementChild.className.includes('noCloseFilters')) found = true
                    if(target.firstElementChild && target.firstElementChild.className.includes('noCloseFilters')) found = true
                    if(target.parentNode) if (target.parentNode.className.includes('btnFilter')) found = true
                    if(target.parentNode) if (target.parentNode.className.includes('cell')) found = true
                    if(target.parentNode) if (target.parentNode.className.includes('mx-date-row')) found = true
                    target = target.offsetParent
                }

                if(found) return
            }
            this.filterDrawerWidth = '0px'
            if(this.floatingAvatarmenu) this.floatingAvatarmenu.style.right ='8px'
            if(this.floatingWarnings && this.floatingWarnings.length) for(const fw of this.floatingWarnings) fw.style.right ='8px'
        },
        addFilterValue(stringFilter, filter) {
            filter.values.push(stringFilter)
            filter.text = ''
        },
        clearFilters() {
            this.setFilters({
                ID:{label:'ID', title:translate('Nº', 'AtendimentosTable'), values:[]},
                ACAO_COM_USUARIO_ID: {label:'ACAO_COM_USUARIO_ID', title:translate('Ação Com', 'AtendimentosTable'), values:[], exception: false},
                CLIENTE_ID: {label:'CLIENTE_ID', title:translate('Cliente', 'AtendimentosTable'), values:[], exception: false},
                DATA_INICIO: {label:'DATA_INICIO', title:translate('Dt. Ini.', 'AtendimentosTable'), values:[]},
                DATA_LIMITE: {label:'DATA_LIMITE', title:translate('Dt. Limite', 'AtendimentosTable'), values:[]},
                SOLICITANTE_ID: {label:'SOLICITANTE_ID', title:translate('Solicitante', 'AtendimentosTable'), values:[], exception: false},
                RESPONSAVEL_ID: {label:'RESPONSAVEL_ID', title:translate('Responsável', 'AtendimentosTable'), values:[], exception: false},
                SITUACAO_ID: {label:'SITUACAO_ID', title:translate('Situação', 'AtendimentosTable'), values:[], exception: false},
                NAO_LIDOS: {label:'NAO_LIDOS', title:translate('Não lidos', 'AtendimentosTable'), values:[]},
                TEXTO_MENSAGEM: {label: 'TEXTO_MENSAGEM', title:translate('Termo mensagem', 'AtendimentosTable'), values:[]},
                SETOR_ID: {label: 'SETOR_ID', title:translate('Setor', 'AtendimentosTable'), values:[], exception: false},
            })
        },
        removeFilterAndGetCalls(filter){
            var arrFilters = Object.values(this.filters)
            for(let i = 0; i < arrFilters.length; i++){
                if(arrFilters[i].title == filter.title){
                    arrFilters[i].values = arrFilters[i].values.filter(function(item){
                        return item.ID != filter.value.ID
                    })
                }
                this.filters[arrFilters[i].label] = arrFilters[i]
            }
            this.setFilterValues([])
            this.setFilters(this.filters)
            this.getAllCallsBySituation()
        },
        enableDate(){
            return this.filters.DATA_INICIO.values[0]
        },
        enableEndDate(){
            return this.filters.DATA_LIMITE.values[0]
        },
        getRouteParams(){
            this.routeParams = {
                id: this.$route.params.id ? JSON.parse(this.$route.params.id) : null,
                tab: this.$route.params.tab ? JSON.parse(this.$route.params.tab) : null
            }

            return this.routeParams
        },
        async reloadAtendimentos(){
            await this.$nextTick()
            const previousId = this.routeParams.id
            const { id } = this.getRouteParams()
            if(previousId !== id) this.atendimentos = []
            this.getRouteAction()
        },
        getEmptyFilterOptions(){
            return {
                clients: [],
                responsibles: [],
                calls: [],
                callRequesters: [],
                callResponsibles: [],
                situations: [],
                sections: []
            }
        }
    },
    created() {
        // this.clearFilters()
        // this.setFilterValues([])
        
        this.getRouteParams()
        eventBus.$on('reloadAtendimentosTable', this.reloadAtendimentos)

        if (!this.filterOptions) this.setFilterOptions(this.getEmptyFilterOptions())

        this.isUserOperator = !this.user.CLIENTE_ID
    },
    beforeDestroy(){
        eventBus.$off('reloadAtendimentosTable', this.reloadAtendimentos)
    },
    async mounted() {
        this.atendimentos = []
        this.onResize()
    }
}
</script>
<style lang="scss" scoped="true">
.btn1{
    text-transform: none !important;
}
.bodyPage{
    padding-top:8%;
}
.text-left{
    text-align: left;
}
.tableCalls{
    width: 99%;
}
.mini-padding{
    margin: 0;
    padding:8px;
}
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
.headerbuttons{
    padding-bottom: 2em;
    display: flex;
}
.marginRight{
    margin-right: 1em;
}
.assuntoColumn{
    max-width: 200px;
}
.chipSituation{
    width: 100%;
    justify-content: center;
}
.labelBadge{
    display: flex;
    position: relative;
    justify-content: center;
}
.badge{
    position: absolute;
    margin-right: 2.8em;
    top: -8px;
    background-color: #d93025;
    width: min-content;
    height: 14px;
    border-radius: 50px;
    min-width: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.badge > span{
    font-size: 10px;
    position: relative;
    color: white;
    padding: 2px;
}
.filtersDrawer{
    height: 96% !important;
}
.filtersBody{
    padding: 10px;
    height: 81%;
    scrollbar-width: thin;
    overflow: auto;
}
.filtersBody::-webkit-scrollbar {
    width: 8px;
}

.filtersBody::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.filtersBody::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.filtersFooter{
    padding: 10px;
    display: flex;

}
.filtersColumn{
    margin-left: 4px;
    padding-bottom: 2px; 
    display: inline-block; 
    align-items: center; 
    overflow-x: auto; 
    white-space: nowrap;
    height: fit-content;
    padding-top: 18px;
}
.filtersColumn::-webkit-scrollbar {
    height: 8px;
}

.filtersColumn::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.filtersColumn::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}

.exception-label {
    font-size: 16px; 
    font-family: Baloo 2, cursive; 
    position: absolute; 
    left: 0; 
    color: rgba(0, 0, 0, 0.6);
}

@media only screen and (max-width: 539px){
    .assuntoColumn{
        max-width: 40px;
    }
    .tableCalls{
        width: 100%;
    }
}
@media only screen and (min-width: 540px) and (max-width: 739px){
    .assuntoColumn{
        max-width: 100px;
    }
    .tableCalls{
        width: 100%;
    }
}
@media only screen and (min-width: 601px) and (max-width: 820px){
    .assuntoColumn{
        max-width: 160px;
    }
    .tableCalls{
        width: 100%;
    }
}
</style>